import Modal from "@/common/elements/Modal";
import AddDetention, { MODE } from "../AddDetention";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBookings } from "@/slices/bookingsSlice";
import dayjs from "dayjs";
import { hasCheckSecurity, isNonEmptyVariable } from "@/util/common_function";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import { MODULES_LIST_WITH_ID, SUB_MODULES_LIST_WITH_ID } from "@/util/common_variable";

const EditDetentionsModal = ({
  show,
  onHide,
  formData,
  isEdit = false,
  allDetentionData = [],
}) => {
  const formRef = useRef();
  const dispatch = useDispatch();
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  useEffect(() => {}, [formData]);

  const onModalHide = () => {
    onHide();
  };

  const onSaveChanges = () => {
    const values = formRef.current.getFormValues();
    let allDetentionDataCopy = allDetentionData;

    if (isEdit) {
      allDetentionDataCopy = allDetentionDataCopy?.map((ad) => {
        if (ad?.uuid === formData?.uuid) {
          return {
            ...ad,
            detentionsArrestReports: ad?.detentionsArrestReports?.map((a) => {
              return {
                ...a,
                ...values,
                controllingAgencyCaseNumber:
                  isNonEmptyVariable(values?.controllingAgencyCaseNumber) &&
                  !isNaN(values?.controllingAgencyCaseNumber)
                    ? parseInt(values?.controllingAgencyCaseNumber)
                    : null,
                housedFor: values?.housedFor
                  ? dayjs(values?.housedFor)?.format("MM/DD/YYYY")
                  : null,
                incarcerationDate: values?.incarcerationDateTime
                  ? dayjs(values?.incarcerationDateTime)?.format("MM/DD/YYYY")
                  : null,
                incarcerationTime: values?.incarcerationDateTime
                  ? dayjs(values?.incarcerationDateTime)?.format("HH:mm")
                  : null,
                releaseDate: values?.releaseDateTime
                  ? dayjs(values?.releaseDateTime)?.format("MM/DD/YYYY")
                  : null,
                releaseTime: values?.releaseDateTime
                  ? dayjs(values?.releaseDateTime)?.format("HH:mm")
                  : null,
              };
            }),
          };
        } else {
          return ad;
        }
      });
    }

    dispatch(
      setBookings({
        detentions: allDetentionDataCopy,
      })
    );

    onModalHide();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onModalHide}
        header="Detention"
        designPattern="ant"
        width="75%"
        footerActionsNeed={false}
        footerCloseAction
        footerCloseActionText="Close"
        scrollable
      >
        <AddDetention
          formData={formData}
          mode={MODE.EDIT}
          formRef={formRef}
          bookingsFieldsEnabled={bookingsFieldsEnabled}
          disabled={!bookingsFieldsEnabled}
        />
      </Modal>
    </>
  );
};

export default EditDetentionsModal;
